import type { HttpClientRequestConfig } from "core/http/types";

/** Scope riêng cho tra cứu thu nhập — tách khỏi `DEFAULT_VERIFICATION_SCOPE`. */
export const INCOME_VERIFICATION_SCOPE = "income" as const;

/**
 * Cấu hình GET income: bật luồng OTP trong `HttpClient._handleRequest`.
 * Sau khi user xác thực, token section được gắn header section cho **chính request này**
 * (không cần khai báo section trong service).
 */
export const getIncomeHttpConfig = {
  requiresVerification: true,
  verificationScope: INCOME_VERIFICATION_SCOPE,
} satisfies HttpClientRequestConfig;
